export default __webpack_public_path__ + "static/media/icon-vidraceiro.c64f6080.svg";